import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { FIREBASE_CONFIG } from '../../utils/constants';

// ── Security: Validate required Firebase config fields (A05) ─────────────────
// Only initialize if ALL critical fields are present so that partial config
// doesn't create a broken Firebase instance.
const REQUIRED_FIELDS = ['apiKey', 'authDomain', 'projectId'];
const missingFields = REQUIRED_FIELDS.filter(
  (f) => !FIREBASE_CONFIG[f] || FIREBASE_CONFIG[f].trim() === ''
);

let app = null;
let auth = null;
let db = null;

if (missingFields.length === 0) {
  if (getApps().length === 0) {
    app = initializeApp(FIREBASE_CONFIG);
  } else {
    app = getApps()[0];
  }

  try {
    auth = getAuth(app);
    db = getFirestore(app);
  } catch (e) {
    console.error('[car-alert] Erro ao inicializar serviços Firebase:', e);
  }
} else {
  console.error(
    '[car-alert] Firebase não inicializado — campos obrigatórios ausentes: ' +
      missingFields.join(', ') +
      '. Verifique as variáveis de ambiente REACT_APP_FIREBASE_* em frontend/.env.local.'
  );
}

export { auth, db };
export default app;
